const SELECTOR = '[data-action]';
const BUTTONS_SELECTOR = 'input[class^="button"], button[class^="button"]';

class InterceptButtons {
  constructor() {
    if ($(SELECTOR).size()) {
      this.initialize();
    }
  }

  initialize() {
    $('body').on('click touchend', BUTTONS_SELECTOR, event => {
      const actionName = $(event.target).val();

      this.disableAllFields();
      this.enableEligibleField(actionName);

      return true;
    });
  }

  disableAllFields() {
    $('[data-action]').attr('disabled', true);
  }

  enableEligibleField(actionName) {
    if (!actionName) {
      throw new Error(
        `InterceptButtons :: Missing actionName -- cannot enable any hidden field.
        Please make sure your button 'value' attribute is present.`
      );
    }

    $(`[data-action="${actionName}"]`).removeAttr('disabled');
  }
}

export default InterceptButtons;



// WEBPACK FOOTER //
// ./src/javascripts/InterceptButtons.js